import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { startMesh } from './WelcomeTutorial';

const STORAGE_KEY = 'forallia_cookie_notice_accepted';

function getAccepted() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

// Lo que va dentro (children) solo se muestra una vez aceptadas las cookies.
// Hasta aceptarlas la malla del tutorial tapa la web, salvo en la politica de privacidad
// (para poder leerla) y en /redes y /codigos (igual que el tutorial).
function CookieBanner({ children }) {
  const [accepted, setAccepted] = useState(getAccepted);
  const canvasRef = useRef(null);
  const { pathname } = useLocation();
  const blocking = !accepted && !/^\/(privacy|redes|codigos)/i.test(pathname);

  useEffect(() => blocking ? startMesh(canvasRef.current) : undefined, [blocking]);

  if (accepted) return children || null;

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {}
    setAccepted(true);
  };

  return (
    <>
      {blocking && <div className="welcomeOverlay"><canvas ref={canvasRef} className="welcomeMesh" /></div>}
      <div className="avisoSesion heroes">
        <div className="avisoSesion-content">
          <p>
            Este sitio utiliza una cookie esencial (<strong>auth_token</strong>) necesaria para
            mantener tu sesión iniciada, y una segunda cookie esencial
            (<strong>admin_token</strong>) que solo se crea al acceder al panel de
            administración. No utilizamos cookies de seguimiento
            ni de terceros. Para más información, consulta nuestra{' '}
            <Link to="/privacy">Política de Privacidad</Link>.
          </p>
          <button className="avisoSesion-btn" onClick={handleAccept}>
            Aceptar
          </button>
        </div>
      </div>
    </>
  );
}

export default CookieBanner;
